export default __webpack_public_path__ + "static/media/MealPlanMobile_1024.38506fe7.png";